export namespace NgxsAppActions {
  export class Logout {
    static readonly type = '[TopMenu] logout';
    constructor() {}
  }
}
